import { z } from 'zod';

import { stringBooleanSchema } from '@eluve/utils';

const configSchema = z.object({
  VITE_SUPERTOKENS_WEBSITE_DOMAIN: z.string().url(),
  VITE_API_DOMAIN: z.string().url(),
  VITE_APOLLO_CLIENT_URI: z.string().url(),
  VITE_ENV: z.enum(['development', 'production', 'test']).default('production'),
  VITE_METRICS_ENV: z.string().default('local-dev'),
  VITE_ENABLE_SOCIAL_AUTH: stringBooleanSchema,
  VITE_ENABLE_EMAIL_PASSWORD_AUTH: stringBooleanSchema,
  VITE_ENABLE_MAGIC_LINK_LOGIN: stringBooleanSchema,
  VITE_ENABLE_MICROSOFT_LOGIN: stringBooleanSchema,
  VITE_APP_VERSION: z.string().default('0.0.0'),
  VITE_REACT_APP_PUBLIC_POSTHOG_KEY: z.string().min(3),
  VITE_REACT_APP_PUBLIC_POSTHOG_HOST: z
    .string()
    .default('https://us.i.posthog.com'),
  VITE_POSTHOG_PROXY_HOST: z.string().url().optional(),
  VITE_POSTHOG_PROJECT_ID: z.string(),
  VITE_INTERCOM_APP_ID: z.string().default('y6fjw8r1'),
  VITE_USE_LOCAL_LOKI_LOGGER: stringBooleanSchema,
  VITE_WORKTREE_BRANCH: z.string().default('main'),
  VITE_LANGFUSE_BASE_URL: z.string().optional(),
  VITE_LANGFUSE_PROJECT_ID: z.string().optional(),
  VITE_MEDPLUM_BASE_URL: z.string().url().optional(),
});

// Runtime config lives in `window.__APP_CONFIG__`, populated by `/config.js`
// which is:
//   - injected per-env at deploy time (Cloud Deploy target or pulumi-up path)
//   - served by the dev middleware in vite.config.ts for local `nx serve`
//
// We intentionally do NOT fall back to `import.meta.env`: per-env `.env.<env>`
// files live under `apps/web-vite/env/` (outside Vite's auto-load root), so
// `import.meta.env.VITE_*` is empty in the built bundle. If config.js fails
// to load we want a loud crash, not a silent cross-env leak.
const runtime = (window as unknown as { __APP_CONFIG__?: unknown })
  .__APP_CONFIG__;
if (!runtime) {
  throw new Error(
    'Missing window.__APP_CONFIG__ — /config.js did not load. ' +
      'This is a deployment misconfiguration.',
  );
}
export const appConfig = configSchema.parse(runtime);
